// Registro dos ícones fotorrealistas gerados por scripts/render-vehicle-icons/
// a partir de .glb (ver src/assets/vehicle-icons/generated/<modelKey>/<hex>.png).
// import.meta.glob pega tudo automaticamente — adicionar um modelo novo não
// exige tocar neste arquivo, só gerar os PNGs na pasta certa.
const modules = import.meta.glob("../../assets/vehicle-icons/generated/*/*.png", {
  eager: true,
  import: "default",
}) as Record<string, string>;

const FILE_RE = /\/generated\/([^/]+)\/([0-9a-f]{6})\.png$/i;

function buildRegistry(): Record<string, Record<string, string>> {
  const registry: Record<string, Record<string, string>> = {};
  for (const [filePath, url] of Object.entries(modules)) {
    const match = filePath.match(FILE_RE);
    if (!match) continue;
    const [, modelKey, hex] = match;
    (registry[modelKey] ??= {})[hex.toLowerCase()] = url;
  }
  return registry;
}

// { [modelKey]: { [hexSemHash]: url } } — ex.: PHOTO_REGISTRY.hatchback["22c55e"]
export const PHOTO_REGISTRY: Record<string, Record<string, string>> = buildRegistry();

export function resolvePhotoUrl(modelKey: string, hexColor: string): string | undefined {
  return PHOTO_REGISTRY[modelKey]?.[hexColor.replace("#", "").toLowerCase()];
}
